import { useState } from 'react';
import { 
  Button, TextField, Grid, Typography, FormControl, Select, MenuItem, IconButton
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import PropTypes from 'prop-types';

import { isEmpty } from '../../components/common/helpers';
import { getCode, checkUser } from '../../actions/users';

const FormForgetPass2 = ({
  type, data, setData, setPasos
}) => {
  const [disabled, setDisabled] = useState(false);
  const [error, setError] = useState({
    tel: '',
    email: ''
  });

  const continuar = async e => {
    e.preventDefault();
    
    if (data.email == '' && type === 'email') {
      return setError({
        email: 'Campo requerido'
      });
    } 
    
    if (data.tel == '' && type === 'celular') {
      return setError({
        tel: 'Campo requerido'
      });
    }
    const info = {
      email: data.email,
      tel: "52".concat(data.tel),
      subject: "olvido"
    }

    const resCheck = !isEmpty(data.email) ? await checkUser(data.email) : await checkUser(info.tel);

    if(resCheck){
      setError({
        tel: '',
        email: ''
      });
      setDisabled(true)
      const result = await getCode(type, info);
      if(!isEmpty(result)){
        setPasos(3);
      }
      setData({
        ...data,
        codigo: result.codigo,
        userId: resCheck._id
      })
    } else {
      return setError({
        email: 'Usuario no esta registrado',
        tel: 'Usuario no esta registrado'
      });
    }
  }

  const cambiar = e => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const typeValidation = type == 'email'
    ? 'la dirección de correo electrónico'
    : ' el número de teléfono'

  return (
    <form noValidate onSubmit={continuar}>
      <Grid item size={12}>
        <IconButton
          sx={{width: 55, height: 55}}
          className="btn-icon"
          aria-label="back"
          onClick={() => setPasos(1)}
        >
          <ChevronLeftIcon sx={{fontSize: 38}} />
        </IconButton>
      </Grid>
      <Grid container spacing={2} sx={{my: 3}} size={12}>
        <Grid item container direction="column" size={12} mb={3}>
          <Typography variant="h3" component="h3">¿Olvidaste tu contraseña?</Typography>
          <Typography component="p">
            Introduce {typeValidation} vinculado a tu cuenta.
          </Typography>
        </Grid>
        {
          type == "email"
          ? <Grid item size={12}>
              <TextField
                className="input-sigup"
                error={isEmpty(error.email) ? false : true}
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                value={data.email}
                onChange={cambiar}
                helperText={!isEmpty(error.email) && error.email}
              />
            </Grid>
          : <>
              <Grid item size={{xs: 3, sm: 4}}>
                <FormControl sx={{width: "100%"}}>
                  <Select
                    autoWidth
                    name="prefijo"
                    className="input-sigup"
                    value={data.prefijo}
                    onChange={cambiar}
                    IconComponent={() => <ArrowDropDownCircleIcon color="primary" />}
                  >
                    <MenuItem value="52"><img alt="México" width="20" src="/mexico.png" /> +52</MenuItem>
                    <MenuItem value="1"><img alt="EEUU" width="20" src="/eeuu.png" /> +1</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item size={{xs: 9, sm: 8, md: 6}}>
                <TextField
                  error={!isEmpty(error.tel) ? true : false}
                  variant="outlined"
                  required
                  fullWidth
                  id="tel"
                  label="Teléfono"
                  name="tel"
                  value={data.tel}
                  onChange={cambiar}
                  helperText={!isEmpty(error.tel) && error.tel}
                />
              </Grid>
            </>
        }   
      </Grid>
      <Grid item size={12}>
        <Button fullWidth
          variant="contained"
          color="primary"
          type="submit"
          disabled={disabled}
        >
          Enviar código
        </Button>
      </Grid>
    </form>
  )
}

FormForgetPass2.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  setData: PropTypes.func.isRequired,
  setPasos: PropTypes.func.isRequired,
}

export default FormForgetPass2;